import { AppIdentifier } from '@aipb/env/model';
import { InjectionToken } from '@angular/core';

export const APP_REQUIRED_ROLES = new InjectionToken<AppRequiredRoles>('APP_REQUIRED_ROLES');
export const GROUP_DESCRIPTIONS = new InjectionToken<GroupDescriptions>('GROUP_DESCRIPTIONS');

export type AppRequiredRoles = {
  [key in AppIdentifier]: string[];
};

export interface GroupDescriptions {
  [key: string]: string;
}
